import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const SchedulingPage = lazy(() => import('@pages/scheduling/SchedulingPage'));

// Route Component using PageWrapper approach
const SchedulingRouteContainer = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('shifts-scheduling-page-title')}>
        <SchedulingPage />
      </PageWrapper>
    </Suspense>
  );
};

// Export Lazy-Loaded Route
export default { SchedulingRouteContainer };
